// Module
var code = "<div class=\"col-sm-12 form-section-title\"> Provider </div>\n\n<box-selector value=\"$ctrl.value\" options=\"$ctrl.options\" on-change=\"($ctrl.onChange)\" radio-name=\"'oauth_provider'\"></box-selector>\n";
// Exports
var _module_exports = code;;
var path = 'app/portainer/oauth/components/oauth-providers-selector/oauth-providers-selector.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;